import React from "react";
const skeletonArray = new Array(8).fill(0);
const PageLoading = () => {
  return (
    <>
      <table class="tg">
        <tr>
          <th class="tg-cly1">
            <div class="line"></div>
          </th>
          <th class="tg-cly1">
            <div class="line"></div>
          </th>
          <th class="tg-cly1">
            <div class="line"></div>
          </th>
          <th class="tg-cly1">
            <div class="line"></div>
          </th>
          <th class="tg-cly1">
            <div class="line"></div>
          </th>
          <th class="tg-cly1">
            <div class="line"></div>
          </th>
          <th class="tg-cly1">
            <div class="line"></div>
          </th>
          <th class="tg-cly1">
            <div class="line"></div>
          </th>
        </tr>
        {skeletonArray.map((v, i) => (
          <tr key={i}>
            <td class="tg-cly1">
              <div class="line"></div>
            </td>
            <td class="tg-cly1">
              <div class="line"></div>
            </td>
            <td class="tg-cly1">
              <div class="line"></div>
            </td>
            <td class="tg-cly1">
              <div class="line"></div>
            </td>
            <td class="tg-cly1">
              <div class="line"></div>
            </td>
            <td class="tg-cly1">
              <div class="line"></div>
            </td>
            <td class="tg-cly1">
              <div class="line"></div>
            </td>
            <td class="tg-cly1">
              <div class="line"></div>
            </td>
          </tr>
        ))}
      </table>
    </>
  );
};

export default PageLoading;
